export interface Amenity {
  amenityId: number;
  amenityName: string;
  description: string;
  dateAdded: Date;
  updatedAt: Date;
}

export interface Amenity {
  amenityId: number;
  amenityName: string;
  description: string;
  dateAdded: Date;
  updatedAt: Date;
}

export const InitAmenity: Amenity = {
  amenityId: 0,
  amenityName: "",
  description: "",
   dateAdded: new Date(),       // current date/time
  updatedAt: new Date(),       // current date/time
};